//////////////////////////////////////////////////////////////

import { DeviceWithMetadata, WrappingValue } from '@/engine/PlanningAlgorithm/DataTypes';
import type { TTVRValveMetadata } from './TTVRDevices';
import type * as THREE from 'three';

export * from '../common/CardiacDataTypes';

//////////////////////////////////////////////////////////////

export class TTVRValveDevice extends DeviceWithMetadata<TTVRValveMetadata>('DT.TTVRValveDevice', 'Valve') {}

export interface CatheterDefaultParamsT {
  insertionDepth: number;
  zRotationAngleDeg: number;
  primaryRotationAngleDeg: number;
  secondaryRotationAngleDeg: number;
}
export class CatheterDefaultParams extends WrappingValue<CatheterDefaultParamsT>('DT.CatheterDefaultParams') {}

export interface CatheterPathT {
  ptBase: THREE.Vector3;
  ptSecondaryJoint: THREE.Vector3;
  ptPrimaryJoint: THREE.Vector3;
  ptTip: THREE.Vector3;
}
export class CatheterPath extends WrappingValue<CatheterPathT>('DT.CatheterPath') {}
